import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupUnrestrictedContentProps } from './msg-group-unrestricted-content';
import { MsgGroupUnrestrictedContent } from './msg-group-unrestricted-content';

export interface MsgGroupUnrestrictedProps extends MsgGroupUnrestrictedContentProps {}

export const MsgGroupUnrestricted = memo(function MsgGroupUnrestricted({
  message,
}: MsgGroupUnrestrictedProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupUnrestrictedContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
